export const DEALER_EVENTS = {
  INTERNAL_REFERRER: 'internal.referrer',
};
